import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import NutshellToCalendar from './icon-nutshell-to-calendar.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    if (validProps.width && validProps.height) {
        delete validProps.height;
    }

    return <NutshellToCalendar {...validProps} />;
}
SvgComponent.iconName = 'nutshellToCalendar';

export const NutshellToCalendarIcon = svgIconWrapper(SvgComponent);
